import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import engagementImg from "../../assets/engagement.jpg";
import worldImg from "../../assets/world.jpg";
import sinistreImg from "../../assets/sinistre.jpg";
import limiteImg from "../../assets/limite.jpg";

const AvantageSection = () => {
  const { t } = useTranslation("garanties/AvantageSection");

  const avantages = [
    {
      image: engagementImg,
      title: (
        <>
          {t("cards.freedom.title.part1")}
          <Box component="span" sx={{ color: "#FFC22F" }}>
            {" "}{t("cards.freedom.title.highlight")}
          </Box>
        </>
      ),
      subtitle: t("cards.freedom.subtitle")
    },
    {
      image: worldImg,
      title: (
        <>
          {t("cards.world.title.part1")}
          <Box component="span" sx={{ color: "#FFC22F" }}>
            {" "}{t("cards.world.title.highlight")}
          </Box>
        </>
      ),
      subtitle: t("cards.world.subtitle")
    },
    {
      image: sinistreImg,
      title: (
        <>
          {t("cards.claims.title.part1")}
          <Box component="span" sx={{ color: "#FFC22F" }}>
            {" "}{t("cards.claims.title.highlight")}
          </Box>
        </>
      ),
      subtitle: t("cards.claims.subtitle"),
      note: t("cards.claims.note")
    },
    {
      image: limiteImg,
      title: (
        <>
          {t("cards.limit.title.part1")}
          <Box component="span" sx={{ color: "#FFC22F" }}>
            {" "}{t("cards.limit.title.highlight")}
          </Box>
        </>
      ),
      subtitle: t("cards.limit.subtitle")
    }
  ];

  return (
    <Box sx={{ display: "flex", justifyContent: "center", px: 2, mt: 10, mb: 10 }}>
      <Box sx={{ maxWidth: "1200px", width: "100%", fontFamily: "'Poppins', sans-serif" }}>
        {/* Titre de section */}
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2.2rem", md: "3.2rem" },
            textAlign: "center",
            mb: 6,
            color: "#000",
          }}
        >
          {t("section.title.part1")}{" "}
          <Box component="span" sx={{ color: "#FFC22F" }}>
            {t("section.title.highlight")}
          </Box>{" "}
          {t("section.title.part2")}
        </Typography>

        {/* Cartes */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2.5,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {avantages.map((item, index) => (
            <Box
              key={index}
              sx={{
                width: { xs: "100%", sm: 280 },
                maxWidth: "100%",
                height: 380,
                borderRadius: "20px",
                overflow: "hidden",
                position: "relative",
                backgroundImage: `url(${item.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                mx: "auto",
              }}
            >
              <Box
                sx={{
                  height: "130px",
                  width: "100%",
                  px: 2,
                  pt: 2,
                  background: "linear-gradient(to top, rgba(0,0,0,0.85), rgba(0,0,0,0.5))",
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1.3rem",
                    fontWeight: 800,
                    textTransform: "uppercase",
                    lineHeight: 1.2,
                    mb: 0.5,
                  }}
                >
                  {item.title}
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", lineHeight: 1.3 }}>
                  {item.subtitle}
                </Typography>
                {item.note && (
                  <Typography sx={{ fontSize: "0.75rem", color: "#ccc", fontStyle: "italic" }}>
                    {item.note}
                  </Typography>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default AvantageSection;